import React, { useState, useEffect } from 'react';

import { fetchInventory, getReferralStats, getPointLogs, equipItem, redeemPhysicalItem, getRedeemedGallery, getUserProfile } from '../api/api'; // 导入API



// ===================== 数据大本营 =====================

const playerInfoInit = {

  id: 'Funky_8848', name: '放克原住民', level: 2, title: '街头食客', exp: 850, maxExp: 2000,

  avatar: '😎', frame: '🔲'

};



const vipTiers = [

  { level: 1, name: '街区新人', reqExp: 0, perks: '集市挂单最长 3 天' },

  { level: 2, name: '街头食客', reqExp: 500, perks: '解锁头像框、挂单 5 天' },

  { level: 3, name: '放克达人', reqExp: 2000, perks: '挂单 7 天、周边兑换特权' },

  { level: 4, name: '波普领主', reqExp: 5000, perks: '集市免手续费、每月发8折券' },

  { level: 5, name: '派对之王', reqExp: 10000, perks: '优先出餐、挂单无期限' }

];



const initialBackpack = [

  { id: 'a1', type: '头像', name: '墨镜狗', img: '😎', count: 1 },

  { id: 'a2', type: '头像', name: '金芥末', img: '🌭', count: 1 },

  { id: 'a3', type: '头像', name: '嘻哈熊', img: '🐻', count: 1 },

  { id: 'f1', type: '头像框', name: '波普黑框', img: '🔲', count: 1 },

  { id: 't1', type: '票券', name: '8折券', img: '🎫', count: 2, desc: '点餐结算时抵扣' },

  { id: 't2', type: '票券', name: '一口肠券', img: '🍡', count: 5, desc: '线下核销兑换' },

  { id: 's1', type: '贴纸', name: '经典美式', img: '🇺🇸', count: 3, desc: '可兑换实体贴纸' },

  { id: 'c1', type: '卡片', name: '放克元勋', img: '🃏', count: 1, desc: '可兑换实体闪卡' },

  { id: 'frag1', type: '碎片', name: '【一口肠】', img: '🧩', count: 1, targetAmount: 3, targetId: 'ex_ticket_1' },

];



const redeemedHistory = [

  { id: 'r1', type: '贴纸', name: '番茄酱汁', img: '🍅', date: '2026-03-04 14:30', reward: '实体波普贴纸 x1' },

];



const myCollection = [

  { id: 'col1', type: '贴纸', name: '番茄酱汁', img: '🍅', unlocked: true, unlockDate: '2026-02-15' },

  { id: 'col2', type: '卡片', name: '放克元勋', img: '🃏', unlocked: true, unlockDate: '2026-01-01' },

  { id: 'tit1', type: '称号', name: '街区新人', img: '🔰', unlocked: true, unlockDate: '2026-01-01' },

  { id: 'tit2', type: '称号', name: '街头食客', img: '🌭', unlocked: true, unlockDate: '2026-02-28' },

];



const mySquad = [

  { id: 'u1', name: '潮人_Alex', joined: '2026-03-01', firstPurchase: true, totalSpent: 125.5, pointsGen: 12 },

  { id: 'u2', name: '吃货_Bob', joined: '2026-03-03', firstPurchase: false, totalSpent: 0, pointsGen: 0 },

  { id: 'u3', name: '萌新_Cat', joined: '2026-03-04', firstPurchase: true, totalSpent: 288.0, pointsGen: 28 },

];



const referralData = { totalInvited: 3, couponsEarned: 2, totalPointsEarned: 40 };



function Profile() {

  const [activeTab, setActiveTab] = useState('我的背包');

  const [packCategory, setPackCategory] = useState('贴纸');

  const [collectCategory, setCollectCategory] = useState('贴纸');

  const [isRedeemedMode, setIsRedeemedMode] = useState(false);



  const [playerInfo, setPlayerInfo] = useState(playerInfoInit);

  const [selectedItem, setSelectedItem] = useState(null);

  const [showVipModal, setShowVipModal] = useState(false);

  const [showInviteModal, setShowInviteModal] = useState(false);

  const [showAvatarMenu, setShowAvatarMenu] = useState(false);

  const [equipSelector, setEquipSelector] = useState(null);

  const [zoomedCollection, setZoomedCollection] = useState(null);

  const [referralTab, setReferralTab] = useState('squad');



  // 🎒 真实背包数据状态

  const [realInventory, setRealInventory] = useState([]);

  const [inventoryLoading, setInventoryLoading] = useState(false);



  // 🎯 放克合伙人数据状态

  const [referralStats, setReferralStats] = useState(null);

  const [pointLogs, setPointLogs] = useState([]);

  const [referralLoading, setReferralLoading] = useState(false);



  // 👕 真换装系统状态

  const [userProfile, setUserProfile] = useState(null);


  const [showEquipModal, setShowEquipModal] = useState(false);

  const [equipType, setEquipType] = useState(null);



  // 🖼️ 已兑换画廊状态

  const [redeemedGallery, setRedeemedGallery] = useState([]);

  const [galleryLoading, setGalleryLoading] = useState(false);

  const [showGallery, setShowGallery] = useState(false);



  // 🎆 全屏图鉴状态

  const [showFullscreenModal, setShowFullscreenModal] = useState(false);

  const [fullscreenItem, setFullscreenItem] = useState(null);



  // 🎖️ 合伙人等级计算

  const getPartnerLevel = (referralCount) => {

    if (referralCount < 3) return { name: '潜水食客', level: 0, color: '#666' };

    if (referralCount < 10) return { name: '街区召集者', level: 1, color: '#2196F3' };

    if (referralCount < 30) return { name: '放克组长', level: 2, color: '#9C27B0' };

    if (referralCount < 50) return { name: '派对之王', level: 3, color: '#FF9800' };

    return { name: '灵魂布道者', level: 4, color: '#FF5722' };

  };



  // 📦 获取真实背包数据

  useEffect(() => {

    const loadInventory = async () => {

      try {

        setInventoryLoading(true);

        // 使用固定的测试用户ID，实际项目中应该从用户状态获取

        const userId = 'test-user-id';

        const inventoryData = await fetchInventory(userId);

       

        // 将后端数据转换为前端格式

        const formattedInventory = inventoryData.map(item => ({

          id: item.id,

          type: item.type, // STICKER/FRAGMENT/TICKET/VOUCHER

          name: item.name,

          img: getItemEmoji(item.type), // 根据类型显示对应emoji

          count: 1,

          rarity: item.rarity,

          imageUrl: item.imageUrl,

          isRedeemed: item.isRedeemed

        }));

       

        setRealInventory(formattedInventory);

        console.log('🎒 背包数据加载完成:', formattedInventory);

      } catch (error) {

        console.error('❌ 背包数据加载失败:', error);

        // 失败时使用模拟数据

        setRealInventory(initialBackpack);

      } finally {

        setInventoryLoading(false);

      }

    };



    loadInventory();

  }, []);



  // � 获取合伙人数据

  useEffect(() => {

    const loadReferralData = async () => {

      try {

        setReferralLoading(true);

        // 使用固定测试用户ID

        const userId = 'test-user-id';

       

        // 并行获取邀请统计和积分流水

        const [statsData, logsData] = await Promise.all([

          getReferralStats(userId),

          getPointLogs(userId, 20)

        ]);

       

        setReferralStats(statsData.stats);

        setPointLogs(logsData.logs);

       

        console.log('🎯 合伙人数据加载完成:', statsData.stats);

        console.log('💰 积分流水加载完成:', logsData.logs);

      } catch (error) {

        console.error('❌ 合伙人数据加载失败:', error);

        // 失败时使用模拟数据

        setReferralStats({

          user: playerInfoInit,

          referralCount: 2,

          totalConsumption: 156.5,

          totalCommission: 15.65

        });

        setPointLogs([]);

      } finally {

        setReferralLoading(false);

      }

    };



    if (activeTab === '放克小组') {

      loadReferralData();

    }

  }, [activeTab]);



  // 👕 加载用户档案

  useEffect(() => {

    const loadUserProfile = async () => {

      try {

        const userId = 'test-user-id';

        const profileData = await getUserProfile(userId);

        setUserProfile(profileData.profile);

        console.log('👕 用户档案加载完成:', profileData.profile);

      } catch (error) {

        console.error('❌ 用户档案加载失败:', error);

      }

    };



    loadUserProfile();

  }, []);



  // 🖼️ 加载已兑换画廊

  useEffect(() => {

    const loadGallery = async () => {

      try {

        setGalleryLoading(true);

        const userId = 'test-user-id';

        const galleryData = await getRedeemedGallery(userId);

        setRedeemedGallery(galleryData.items);

        console.log('🖼️ 已兑换画廊加载完成:', galleryData.items);

      } catch (error) {

        console.error('❌ 已兑换画廊加载失败:', error);

      } finally {

        setGalleryLoading(false);

      }

    };



    if (showGallery) {

      loadGallery();

    }

  }, [showGallery]);



  // 📦 获取真实背包数据物品类型获取对应emoji

  const getItemEmoji = (type) => {

    const emojiMap = {

      'STICKER': '🎨',

      'FRAGMENT': '🧩',

      'TICKET': '🎫',

      'VOUCHER': '🎟️',

      '头像': '😎',

      '头像框': '🔲',

      '票券': '🎫',

      '贴纸': '🇺🇸',

      '卡片': '🃏'

    };

    return emojiMap[type] || '📦';

  };



  // 🎨 稀有度边框样式

  const getRarityBorder = (rarity) => {

    const borderMap = {

      'COMMON': '2px solid black',

      'RARE': '2px solid #2196F3',

      'EPIC': '2px solid #9C27B0',

      'LEGENDARY': '2px solid #FF9800'

    };

    return borderMap[rarity] || '2px solid black';

  };



  // 🎨 稀有度阴影样式

  const getRarityShadow = (rarity) => {

    const shadowMap = {

      'COMMON': '2px 2px 0 rgba(0,0,0,1)',

      'RARE': '2px 2px 0 rgba(33,150,243,0.8)',

      'EPIC': '2px 2px 0 rgba(156,39,176,0.8)',

      'LEGENDARY': '2px 2px 0 rgba(255,152,0,0.8)'

    };

    return shadowMap[rarity] || '2px 2px 0 rgba(0,0,0,1)';

  };



  // 🎨 稀有度颜色

  const getRarityColor = (rarity) => {

    const colorMap = {

      'COMMON': '#666',

      'RARE': '#2196F3',

      'EPIC': '#9C27B0',

      'LEGENDARY': '#FF9800'

    };

    return colorMap[rarity] || '#666';

  };



  // 🎨 稀有度标签

  const getRarityLabel = (rarity) => {

    const labelMap = {

      'COMMON': '普通',

      'RARE': '稀有',

      'EPIC': '史诗',

      'LEGENDARY': '传奇'

    };

    return labelMap[rarity] || '普通';

  };



  // 👕 处理装备物品

  const handleEquipItem = async (itemType, itemId) => {

    try {

      const userId = 'test-user-id';

      await equipItem(userId, itemType, itemId);
      
      // 关闭装备弹窗
      setShowEquipModal(false);
      setEquipType(null);
      
      alert(`装备成功！${itemType}已更换`);

    } catch (error) {

      alert(`装备失败: ${error.response?.data?.error || error.message}`);

    }

  };



  // 🏬 处理实物核销

  const handleRedeemItem = async (itemId) => {

    try {

      const userId = 'test-user-id';

     

      await redeemPhysicalItem(userId, itemId);

     

      // 重新加载背包和画廊

      const inventoryData = await fetchInventory(userId);

      const formattedInventory = inventoryData.map(item => ({

        id: item.id,

        type: item.type,

        name: item.name,

        img: getItemEmoji(item.type),

        count: 1,

        rarity: item.rarity,

        imageUrl: item.imageUrl,

        isRedeemed: item.isRedeemed

      }));

      setRealInventory(formattedInventory);

     

      // 重新加载画廊

      const galleryData = await getRedeemedGallery(userId);

      setRedeemedGallery(galleryData.items);

     

      alert('核销成功！请前往店铺兑换实物');

     

    } catch (error) {

      alert(`核销失败: ${error.response?.data?.error || error.message}`);

    }

  };



  // 🎆 显示全屏图鉴

  const showFullscreenItem = (item) => {

    setFullscreenItem(item);

    setShowFullscreenModal(true);

  };




 



  // 📦 使用真实背包数据或模拟数据

  const currentPackData = isRedeemedMode ? redeemedHistory : (realInventory.length > 0 ? realInventory : initialBackpack);

  const filteredBackpack = currentPackData.filter(item => item.type === packCategory);

  const filteredCollection = myCollection.filter(item => item.type === collectCategory);



  const renderGridSlots = (items) => {

    const slots = [...items];

    while (slots.length < 16) { slots.push({ isEmpty: true, id: `empty-${slots.length}` }); }

    return slots.slice(0, 16);

  };



  const handleSelectEquip = (item) => {

    if (item.type === '头像') setPlayerInfo(prev => ({ ...prev, avatar: item.img }));

    if (item.type === '头像框') setPlayerInfo(prev => ({ ...prev, frame: item.img }));

    if (item.type === '称号') setPlayerInfo(prev => ({ ...prev, title: item.name }));

    setEquipSelector(null);

  };



  const refCount = mySquad.length;

  const getReferralTier = (count) => {

    if (count < 3) return { name: '潜水食客', current: count, next: 3, percent: (count/3)*100 };

    if (count < 10) return { name: '街区召集者', current: count, next: 10, percent: (count/10)*100 };

    if (count < 30) return { name: '放克组长', current: count, next: 30, percent: (count/30)*100 };

    if (count < 50) return { name: '派对之王', current: count, next: 50, percent: (count/50)*100 };

    return { name: '灵魂布道者', current: count, next: 100, percent: Math.min((count/100)*100, 100) };

  };

  const refTier = getReferralTier(refCount);



  return (

    // 💥 修复：外层彻底 overflow hidden，告别滚动条

    <div style={{ padding: '0px 10px 10px 10px', height: '100%', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', overflow: 'hidden' }}>

     

      {/* 🚀 玩家名片区 - 真换装系统 */}

      <div style={{ background: '#222', color: 'white', padding: '12px 15px', marginBottom: '8px', display: 'flex', alignItems: 'center', border: '4px solid black', boxShadow: '4px 4px 0 #E6B422', flexShrink: 0 }}>

        <div onClick={() => { setEquipType('头像'); setShowEquipModal(true); }} style={{ position: 'relative', width: '85px', height: '85px', border: '3px solid #E6B422', background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0, cursor: 'pointer', boxSizing: 'border-box' }}>

          <div style={{ fontSize: '55px', zIndex: 1, lineHeight: 1 }}>{userProfile?.currentAvatar || playerInfo.avatar}</div>

          {(userProfile?.currentFrame || playerInfo.frame) !== 'none' && (

            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, fontSize: '75px', display: 'flex', justifyContent: 'center', alignItems: 'center', pointerEvents: 'none', zIndex: 2, lineHeight: 1 }}>

              {userProfile?.currentFrame || playerInfo.frame}

            </div>

          )}

        </div>

        <div style={{ marginLeft: '15px', flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <div style={{ fontWeight: '900', fontSize: '18px' }}>{userProfile?.nickname || playerInfo.name} <span style={{ fontSize: '10px', color: '#999' }}>#{(userProfile?.id || playerInfo.id).split('_')[1]}</span></div>

            <div onClick={() => setShowVipModal(true)} style={{ background: '#E6B422', color: 'black', fontSize: '11px', fontWeight: '900', padding: '2px 6px', border: '2px solid black', cursor: 'pointer' }}>Lv.{userProfile?.vipLevel || playerInfo.level} 特权 ▶</div>

          </div>

          <div style={{ display: 'flex' }}>

            <div onClick={() => { setEquipType('称号'); setShowEquipModal(true); }} style={{ background: '#444', color: '#ffd54f', fontSize: '12px', fontWeight: 'bold', padding: '2px 8px', border: '1px solid #E6B422', borderRadius: '12px', cursor: 'pointer' }}>{userProfile?.currentTitle || playerInfo.title}</div>

          </div>

          <div style={{ background: '#000', height: '6px', marginTop: '2px', border: '1px solid #666' }}>

            <div style={{ width: `${(playerInfo.exp / playerInfo.maxExp) * 100}%`, height: '100%', background: '#00E676' }}></div>

          </div>

          <div style={{ background: '#00E676', color: 'black', fontSize: '12px', fontWeight: '900', padding: '4px 12px', border: '2px solid black', borderRadius: '20px', marginTop: '4px', textAlign: 'center', alignSelf: 'flex-start' }}>🪙 积分: 1250</div>

        </div>

      </div>



      {/* 💥 裂变入口横幅 */}

      <div onClick={() => setShowInviteModal(true)} style={{ background: '#ff5252', color: 'white', padding: '12px 15px', border: '4px solid black', boxShadow: '4px 4px 0 #000', marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', fontWeight: '900', flexShrink: 0 }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

          <span style={{ fontSize: '24px' }}>🔥</span>

          <div style={{ display: 'flex', flexDirection: 'column' }}>

            <span style={{ fontSize: '15px' }}>裂变推广 · 放克小组</span>

            <span style={{ fontSize: '11px', color: '#ffd54f' }}>邀请组队，终身享受积分分润！</span>

          </div>

        </div>

        <div style={{ background: 'white', color: 'black', padding: '5px 10px', border: '2px solid black', fontSize: '12px' }}>立即推广</div>

      </div>



      <div style={{ display: 'flex', border: '4px solid black', marginBottom: '8px', flexShrink: 0 }}>

        {['我的背包', '收藏图鉴', '放克小组'].map(tab => (

          <button key={tab} onClick={() => {

            setActiveTab(tab);

            setIsRedeemedMode(false);

          }} style={{ flex: 1, padding: '12px', fontSize: '15px', fontWeight: '900', border: 'none', borderRight: tab !== '放克小组' ? '3px solid black' : 'none', background: activeTab === tab ? 'black' : 'white', color: activeTab === tab ? 'white' : 'black', cursor: 'pointer' }}>{tab}</button>

        ))}

      </div>



      {/* ===================== 🎒 背包区 (极致弹性的 4x4) ===================== */}

      <div style={{ background: isRedeemedMode ? '#2c2c2c' : 'white', border: isRedeemedMode ? '4px solid #666' : '4px solid black', borderRadius: '4px', padding: '6px', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', transition: 'all 0.3s', boxShadow: '4px 4px 0 rgba(0,0,0,0.1)' }}>

       

        {activeTab === '我的背包' && (

          <>

            <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '6px', marginBottom: '4px', flexShrink: 0, alignItems: 'center' }}>

              {['贴纸', '卡片', '票券', '碎片'].map(cat => (

                <button key={cat} onClick={() => setPackCategory(cat)} style={{ padding: '6px 14px', fontSize: '13px', fontWeight: 'bold', border: isRedeemedMode ? '2px solid #555' : '2px solid black', borderRadius: '20px', background: packCategory === cat ? (isRedeemedMode ? '#888' : '#E6B422') : (isRedeemedMode ? '#444' : 'white'), color: packCategory === cat ? (isRedeemedMode ? '#fff' : 'black') : (isRedeemedMode ? '#999' : 'black'), cursor: 'pointer', whiteSpace: 'nowrap' }}>

                  {cat}

                </button>

              ))}

              <div style={{ flex: 1 }}></div>

              <button onClick={() => setIsRedeemedMode(!isRedeemedMode)} style={{ padding: '6px 14px', fontSize: '13px', fontWeight: '900', border: '2px solid black', borderRadius: '20px', background: isRedeemedMode ? '#ff5252' : '#000', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap' }}>

                {isRedeemedMode ? '返回背包' : '已兑换'}

              </button>

            </div>

           

            {/* � 加载状态 */}

            {inventoryLoading && (

              <div style={{

                height: '100%',

                display: 'flex',

                justifyContent: 'center',

                alignItems: 'center',

                background: '#f5f5f5',

                border: '2px dashed #ccc',

                borderRadius: '4px',

                color: '#666',

                fontWeight: '900',

                fontSize: '14px'

              }}>

                🎒 背包加载中...

              </div>

            )}

           

            {/* �💥 核心：height 100% 确保 4 行绝对吃满屏幕，不溢出 */}

            {!inventoryLoading && (

              <div style={{ height: '100%', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gridTemplateRows: 'repeat(4, minmax(0, 1fr))', gap: '4px' }}>

                {renderGridSlots(filteredBackpack).map((item, idx) => (

                  item.isEmpty ? (

                    <div key={`pack-emp-${idx}`} style={{ border: isRedeemedMode ? '2px dashed #555' : '2px dashed #ccc', background: isRedeemedMode ? '#333' : '#f9f9f9', borderRadius: '4px' }}></div>

                  ) : (

                    <div key={item.id} onClick={() => setSelectedItem(item)} style={{

                      border: getRarityBorder(item.rarity),

                      background: isRedeemedMode ? '#444' : '#fff',

                      display: 'flex',

                      flexDirection: 'column',

                      alignItems: 'center',

                      cursor: 'pointer',

                      position: 'relative',

                      borderRadius: '4px',

                      overflow: 'hidden',

                      filter: isRedeemedMode ? 'grayscale(30%)' : 'none',

                      boxShadow: getRarityShadow(item.rarity)

                    }}>

                      {/* 🎨 稀有度标记 */}

                      {item.rarity && item.rarity !== 'COMMON' && (

                        <div style={{

                          position: 'absolute',

                          top: '2px',

                          right: '2px',

                          background: getRarityColor(item.rarity),

                          color: 'white',

                          fontSize: '8px',

                          fontWeight: 'bold',

                          padding: '1px 3px',

                          borderRadius: '3px',

                          zIndex: 10

                        }}>

                          {getRarityLabel(item.rarity)}

                        </div>

                      )}

                     

                      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '24px' }}>{item.img}</div>

                      <div style={{ background: isRedeemedMode ? '#000' : '#f0f0f0', color: isRedeemedMode ? '#E6B422' : '#000', width: '100%', textAlign: 'center', fontSize: '9px', fontWeight: '900', padding: '2px 0', borderTop: getRarityBorder(item.rarity), whiteSpace: 'nowrap', overflow: 'hidden' }}>{item.name}</div>

                      {!isRedeemedMode && <div style={{ position: 'absolute', top: 0, left: 0, background: 'black', color: 'white', fontSize: '9px', fontWeight: 'bold', padding: '1px 3px' }}>x{item.count}</div>}

                    </div>

                  )

                ))}

              </div>

            )}

          </>

        )}



        {activeTab === '收藏图鉴' && (

          <>

            <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexShrink: 0 }}>

              {['贴纸', '卡片', '称号'].map(cat => (

                <button key={cat} onClick={() => setCollectCategory(cat)} style={{ flex: 1, padding: '4px', fontSize: '12px', fontWeight: 'bold', border: '2px solid black', borderRadius: '5px', background: collectCategory === cat ? 'black' : 'white', color: collectCategory === cat ? 'white' : 'black' }}>{cat}</button>

              ))}

            </div>

            <div style={{ height: '100%', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gridTemplateRows: 'repeat(4, minmax(0, 1fr))', gap: '4px' }}>

              {renderGridSlots(filteredCollection).map((item, idx) => (

                item.isEmpty ? (

                  <div key={`col-emp-${idx}`} style={{ border: '2px dashed #eee', background: '#fafafa', borderRadius: '4px' }}></div>

                ) : (

                  <div key={item.id} onClick={() => { if(item.unlocked) setZoomedCollection(item); }} style={{ border: '2px solid black', background: item.unlocked ? '#fffde7' : '#eee', display: 'flex', flexDirection: 'column', textAlign: 'center', position: 'relative', borderRadius: '4px', overflow: 'hidden', cursor: item.unlocked ? 'pointer' : 'default' }}>

                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '24px', filter: item.unlocked ? 'none' : 'grayscale(100%) brightness(20%)' }}>{item.img}</div>

                    <div style={{ fontSize: '9px', fontWeight: '900', color: item.unlocked ? 'black' : '#999', background: '#f0f0f0', borderTop: '1px solid black', padding: '2px 0', whiteSpace: 'nowrap', overflow: 'hidden' }}>{item.unlocked ? item.name : '???'}</div>

                    {item.unlocked && <div style={{ position: 'absolute', top: 0, left: 0, background: '#00E676', color: 'white', fontSize: '8px', padding: '1px 3px', fontWeight: 'bold' }}>点亮</div>}

                  </div>

                )

              ))}

            </div>

          </>

        )}



        {/* ===================== 🎯 放克小组区 (极致干净的波普风) ===================== */}

        {activeTab === '放克小组' && (

          <>

            {/* 🔄 加载状态 */}

            {referralLoading && (

              <div style={{

                height: '100%',

                display: 'flex',

                justifyContent: 'center',

                alignItems: 'center',

                background: '#f5f5f5',

                border: '2px dashed #ccc',

                borderRadius: '4px',

                color: '#666',

                fontWeight: '900',

                fontSize: '14px'

              }}>

                🎯 小组数据加载中...

              </div>

            )}



            {/* 📊 合伙人数据展示 */}

            {!referralLoading && referralStats && (

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', height: '100%' }}>

               

                {/* a) 阶梯称号展示 */}

                <div style={{

                  background: 'white',

                  border: '4px solid black',

                  padding: '15px',

                  textAlign: 'center',

                  boxShadow: '4px 4px 0 rgba(0,0,0,0.1)'

                }}>

                  <div style={{ fontSize: '24px', marginBottom: '8px' }}>🏆</div>

                  <div style={{

                    fontSize: '18px',

                    fontWeight: '900',

                    color: getPartnerLevel(referralStats.referralCount).color,

                    marginBottom: '5px'

                  }}>

                    {getPartnerLevel(referralStats.referralCount).name}

                  </div>

                  <div style={{ fontSize: '12px', color: '#666' }}>

                    已邀请 {referralStats.referralCount} 人

                  </div>

                  <div style={{ fontSize: '11px', color: '#999', marginTop: '5px' }}>

                    总消费: {referralStats.totalConsumption} 元 | 总提成: {referralStats.totalCommission} 积分

                  </div>

                </div>



                {/* b) 专属邀请码提取 */}

                <div style={{

                  background: '#E6B422',

                  border: '4px solid black',

                  padding: '20px',

                  textAlign: 'center',

                  boxShadow: '4px 4px 0 rgba(0,0,0,0.1)'

                }}>

                  <div style={{ fontSize: '16px', fontWeight: '900', color: 'black', marginBottom: '15px' }}>

                    🎯 我的专属邀请码

                  </div>

                  <div style={{

                    background: 'white',

                    border: '3px solid black',

                    padding: '15px',

                    fontSize: '20px',

                    fontWeight: '900',

                    letterSpacing: '2px',

                    marginBottom: '15px',

                    cursor: 'pointer'

                  }} onClick={() => {

                    navigator.clipboard.writeText(referralStats.user.inviteCode || 'FUNKY8848');

                    alert('邀请码已复制到剪贴板！');

                  }}>

                    {referralStats.user.inviteCode || 'FUNKY8848'}

                  </div>

                  <div style={{ fontSize: '11px', color: 'black', fontWeight: 'bold' }}>

                    👆 点击复制邀请码

                  </div>

                </div>



                {/* c) 佣金流水表 */}

                <div style={{

                  background: 'white',

                  border: '4px solid black',

                  padding: '15px',

                  flex: 1,

                  overflow: 'hidden',

                  display: 'flex',

                  flexDirection: 'column',

                  boxShadow: '4px 4px 0 rgba(0,0,0,0.1)'

                }}>

                  <div style={{ fontSize: '16px', fontWeight: '900', marginBottom: '10px', textAlign: 'center' }}>

                    💰 佣金流水

                  </div>

                  <div style={{

                    flex: 1,

                    overflowY: 'auto',

                    border: '2px solid #ccc',

                    background: '#fafafa'

                  }}>

                    {pointLogs.length === 0 ? (

                      <div style={{

                        padding: '20px',

                        textAlign: 'center',

                        color: '#999',

                        fontSize: '12px'

                      }}>

                        暂无佣金流水

                      </div>

                    ) : (

                      pointLogs.map((log, index) => (

                        <div key={log.id} style={{

                          borderBottom: '1px solid #eee',

                          padding: '8px 10px',

                          fontSize: '11px',

                          display: 'flex',

                          justifyContent: 'space-between',

                          alignItems: 'center'

                        }}>

                          <div>

                            <div style={{ fontWeight: 'bold', color: '#333' }}>

                              {log.reason === 'REFERRAL_BONUS' ? '🎉 邀请奖励' :

                               log.reason === 'CONSUMPTION_COMMISSION' ? '💰 消费提成' :

                               log.reason === 'FIRST_ORDER_BONUS' ? '🎁 首单奖励' :

                               log.reason === 'LISTING_FEE' ? '📤 上架手续费' : log.reason}

                            </div>

                            <div style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>

                              {new Date(log.createdAt).toLocaleString()}

                            </div>

                          </div>

                          <div style={{

                            fontWeight: '900',

                            color: log.amount > 0 ? '#00E676' : '#ff5252',

                            fontSize: '14px'

                          }}>

                            {log.amount > 0 ? '+' : ''}{log.amount} 积分

                          </div>

                        </div>

                      ))

                    )}

                  </div>

                </div>



              </div>

            )}

          </>

        )}

      </div>



      {/* ===================== 💥 弹窗交互区 ===================== */}

     

      {/* 换装面板真实读取 initialBackpack 的头像数据 */}

      {showAvatarMenu && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>

          <div style={{ background: 'white', border: '4px solid black', width: '100%', maxWidth: '280px', padding: '20px', textAlign: 'center', boxShadow: '8px 8px 0 #E6B422' }}>

            <h3 style={{ margin: '0 0 20px 0', fontWeight: '900' }}>更换形象</h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

              <button onClick={() => { setShowAvatarMenu(false); setEquipSelector('头像'); }} style={{ padding: '12px', background: '#E6B422', border: '3px solid black', fontWeight: '900' }}>更换头像</button>

              <button onClick={() => { setShowAvatarMenu(false); setEquipSelector('头像框'); }} style={{ padding: '12px', background: '#fff', border: '3px solid black', fontWeight: '900' }}>更换头像框</button>

              <button onClick={() => setShowAvatarMenu(false)} style={{ padding: '12px', background: '#ccc', border: '3px solid black', fontWeight: 'bold', marginTop: '5px' }}>取消</button>

            </div>

          </div>

        </div>

      )}

     

      {equipSelector && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>

          <div style={{ background: 'white', border: '5px solid black', width: '100%', maxWidth: '300px', maxHeight: '70vh', display: 'flex', flexDirection: 'column' }}>

            <div style={{ background: 'black', color: 'white', padding: '15px', textAlign: 'center', fontWeight: '900' }}>请选择 {equipSelector}</div>

            <div style={{ padding: '15px', overflowY: 'auto', display: 'grid', gridTemplateColumns: equipSelector === '称号' ? '1fr' : 'repeat(3, 1fr)', gap: '10px' }}>

              {equipSelector === '称号' ? (

                myCollection.filter(i => i.type === '称号' && i.unlocked).map(item => (

                  <div key={item.id} onClick={() => handleSelectEquip(item)} style={{ border: '3px solid black', background: '#E6B422', padding: '10px', textAlign: 'center', fontWeight: '900', cursor: 'pointer' }}>{item.name}</div>

                ))

              ) : (

                /* 💥 真实读取背包 */

                initialBackpack.filter(i => i.type === equipSelector).map((item, idx) => (

                  <div key={idx} onClick={() => handleSelectEquip(item)} style={{ border: '3px solid black', padding: '10px', textAlign: 'center', cursor: 'pointer', background: '#fafafa' }}>

                    <div style={{ fontSize: '40px' }}>{item.img}</div>

                  </div>

                ))

              )}

            </div>

            <button onClick={() => setEquipSelector(null)} style={{ margin: '10px', padding: '10px', background: '#ccc', border: '3px solid black', fontWeight: 'bold' }}>取消</button>

          </div>

        </div>

      )}



      {zoomedCollection && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(5px)', padding: '20px' }}>

          <div style={{ background: 'white', border: '5px solid black', width: '100%', maxWidth: '320px', display: 'flex', flexDirection: 'column', boxShadow: '0 0 40px #E6B422', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>

            <div style={{ background: '#E6B422', padding: '15px', borderBottom: '4px solid black', fontWeight: '900', fontSize: '18px' }}>🎉 荣誉典藏馆</div>

            <div style={{ padding: '40px 20px', background: 'radial-gradient(circle, #fffde7 0%, #fff 100%)' }}>

              <div style={{ fontSize: '100px', filter: 'drop-shadow(5px 5px 0px rgba(0,0,0,0.2))' }}>{zoomedCollection.img}</div>

              <h2 style={{ margin: '20px 0 10px 0', fontWeight: '900', fontSize: '28px', color: '#8b2e1f' }}>{zoomedCollection.name}</h2>

              <div style={{ display: 'inline-block', background: 'black', color: 'white', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>{zoomedCollection.type}</div>

            </div>

            <div style={{ background: '#fafafa', padding: '20px', borderTop: '4px dashed #ccc' }}>

              <p style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#666', fontWeight: 'bold' }}>⭐ 解锁时间：{zoomedCollection.unlockDate}</p>

            </div>

            <button onClick={() => setZoomedCollection(null)} style={{ background: 'black', color: 'white', border: 'none', padding: '15px', fontSize: '18px', fontWeight: '900', cursor: 'pointer' }}>收起画卷</button>

          </div>

        </div>

      )}



      {selectedItem && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>

          <div style={{ background: isRedeemedMode ? '#222' : 'white', color: isRedeemedMode ? 'white' : 'black', border: isRedeemedMode ? '4px solid #8b2e1f' : '4px solid black', width: '100%', maxWidth: '300px', padding: '20px', textAlign: 'center', boxShadow: isRedeemedMode ? '8px 8px 0 #000' : '8px 8px 0 #E6B422' }}>

            <div style={{ fontSize: '60px', marginBottom: '10px', filter: isRedeemedMode ? 'grayscale(50%)' : 'none' }}>{selectedItem.img}</div>

            <h3 style={{ margin: '0 0 5px 0', fontWeight: '900' }}>{selectedItem.name}</h3>

           

            {isRedeemedMode ? (

              <div style={{ background: '#000', padding: '10px', border: '1px solid #444', marginTop: '10px', marginBottom: '15px' }}>

                <p style={{ margin: '0 0 5px 0', fontSize: '12px', color: '#E6B422' }}>核销时间: {selectedItem.date}</p>

                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#00E676', fontWeight: 'bold' }}>已领取: {selectedItem.reward}</p>

              </div>

            ) : (

              <p style={{ margin: '0 0 15px 0', color: '#666', fontSize: '14px' }}>

                {selectedItem.type === '碎片' ? `进度: ${selectedItem.count} / ${selectedItem.targetAmount}` : `拥有: ${selectedItem.count} 个`}

              </p>

            )}



            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

              {!isRedeemedMode && ['STICKER', 'TICKET'].includes(selectedItem.type) && (

                <button onClick={() => handleRedeemItem(selectedItem.id)} style={{ width: '100%', padding: '15px', background: '#ff5252', color: 'white', border: '3px solid black', fontWeight: '900', fontSize: '16px', boxShadow: '4px 4px 0 rgba(0,0,0,0.1)' }}>🏬 去店铺兑换实物</button>

              )}

              {/* 🎆 稀有卡片全屏图鉴 */}

              {!isRedeemedMode && selectedItem.type === 'CARD' && selectedItem.rarity && selectedItem.rarity !== 'COMMON' && (

                <button onClick={() => showFullscreenItem(selectedItem)} style={{ width: '100%', padding: '15px', background: '#9C27B0', color: 'white', border: '3px solid black', fontWeight: '900', fontSize: '16px', boxShadow: '4px 4px 0 rgba(0,0,0,0.1)' }}>� 查看全屏图鉴</button>

              )}

              {!isRedeemedMode && (

                <div style={{ display: 'flex', gap: '10px' }}>

                   <button onClick={() => setSelectedItem(null)} style={{ flex: 1, padding: '10px', background: '#ccc', border: '2px solid black', fontWeight: 'bold' }}>取消</button>

                   {selectedItem.type === 'FRAGMENT' ? (

                     <button onClick={() => { localStorage.setItem('jumpIntent', JSON.stringify({ action: 'exchange', targetId: selectedItem.targetId })); document.querySelectorAll('.bottom-nav button')[2].click(); }} style={{ flex: 1, padding: '10px', background: '#00E676', border: '2px solid black', fontWeight: '900' }}>去合成</button>

                   ) : (

                     <button onClick={() => { localStorage.setItem('marketUpload', JSON.stringify(selectedItem)); document.querySelectorAll('.bottom-nav button')[2].click(); }} style={{ flex: 1, padding: '10px', background: '#E6B422', border: '2px solid black', fontWeight: '900' }}>去上架</button>

                   )}

                </div>

              )}

              {isRedeemedMode && (

                <button onClick={() => setSelectedItem(null)} style={{ width: '100%', padding: '10px', background: '#555', color: 'white', border: '2px solid black', fontWeight: 'bold' }}>关闭记录</button>

              )}

            </div>

          </div>

        </div>

      )}



      {/* 💥 详尽裂变中心：进度条 + 小组名单 + 海报 */}

      {showInviteModal && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px' }}>

          <div style={{ background: '#fff', border: '5px solid black', width: '100%', maxWidth: '380px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '10px 10px 0 #E6B422', position: 'relative' }}>

            <button onClick={() => setShowInviteModal(false)} style={{ position: 'absolute', top: '-15px', right: '-15px', background: '#ff5252', border: '4px solid black', width: '40px', height: '40px', borderRadius: '50%', fontWeight: '900', fontSize: '20px', color: 'white', cursor: 'pointer', zIndex: 10 }}>X</button>
            <div style={{ background: 'black', color: 'white', padding: '15px', textAlign: 'center', borderBottom: '4px solid #E6B422' }}>

              <span style={{ fontSize: '20px', fontWeight: '900', marginBottom: '10px', color: '#E6B422' }}>🤝 合伙人等级</span>

              <div style={{ background: '#222', padding: '10px', border: '2px solid #555', borderRadius: '8px', marginBottom: '10px' }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>

                  <span style={{ fontWeight: 'bold', color: '#00E676', fontSize: '14px' }}>等级: {refTier.name}</span>
                  <span style={{ fontWeight: 'bold', color: '#00E676', fontSize: '14px' }}>进度: {refTier.name}</span>

                  <span style={{ fontSize: '12px', color: '#aaa' }}>{refTier.current} / {refTier.next} 人</span>

                </div>

                <div style={{ background: '#000', height: '10px', border: '1px solid #E6B422', overflow: 'hidden' }}>

                  <div style={{ width: `${refTier.percent}%`, height: '100%', background: '#E6B422' }}></div>

                </div>

              </div>

              <div style={{ display: 'flex', justifyContent: 'space-around' }}>

                <div><div style={{ fontSize: '20px', fontWeight: '900', color: '#00E676' }}>+{referralData.totalPointsEarned}</div><div style={{ fontSize: '10px', color: '#aaa' }}>躺赚分润积分</div></div>

                <div><div style={{ fontSize: '20px', fontWeight: '900', color: '#ff5252' }}>{referralData.couponsEarned} 张</div><div style={{ fontSize: '10px', color: '#aaa' }}>累计获赠神券</div></div>

              </div>

            </div>



            <div style={{ display: 'flex', borderBottom: '3px solid black', flexShrink: 0 }}>

              {['放克小组', '推广海报', '特权明细'].map(tab => (

                <button key={tab} onClick={() => setReferralTab(tab === '放克小组' ? 'squad' : tab === '推广海报' ? 'poster' : 'tiers')} style={{ flex: 1, padding: '10px 0', fontSize: '13px', fontWeight: '900', border: 'none', borderRight: tab !== '特权明细' ? '2px solid black' : 'none', background: (referralTab === 'squad' && tab === '放克小组') || (referralTab === 'poster' && tab === '推广海报') || (referralTab === 'tiers' && tab === '特权明细') ? '#E6B422' : '#f0f0f0', cursor: 'pointer' }}>{tab}</button>

              ))}

            </div>

           

            {referralTab === 'squad' && (

              <div style={{ padding: '15px', overflowY: 'auto', flex: 1, background: '#fafafa' }}>

                <div style={{ background: '#ffebee', border: '2px dashed #ff5252', padding: '10px', fontSize: '11px', color: '#b71c1c', marginBottom: '15px' }}>

                  <strong>💰 积分引擎：</strong> 邀请的新人后续每消费 10 元，您将获得 1 积分分润！（系统累计小数，满1元自动发分）

                </div>

                {mySquad.map(user => (

                  <div key={user.id} style={{ border: '2px solid black', background: 'white', padding: '10px', marginBottom: '10px', position: 'relative' }}>

                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900', fontSize: '14px' }}>

                      <span>{user.name}</span><span style={{ color: '#00E676' }}>+{user.pointsGen} 分</span>

                    </div>

                    <div style={{ fontSize: '10px', color: '#666', marginTop: '5px' }}>加入时间：{user.joined}</div>

                    <div style={{ fontSize: '10px', color: '#666' }}>累计消费：¥{user.totalSpent}</div>

                    {user.firstPurchase ? (

                      <div style={{ position: 'absolute', top: '-8px', right: '10px', background: '#ff5252', color: 'white', fontSize: '9px', padding: '2px 5px', border: '1px solid black', fontWeight: 'bold' }}>已发8折券</div>

                    ) : (

                      <div style={{ position: 'absolute', top: '-8px', right: '10px', background: '#ccc', color: '#666', fontSize: '9px', padding: '2px 5px', border: '1px solid black', fontWeight: 'bold' }}>未首次消费</div>

                    )}

                  </div>

                ))}

              </div>

            )}



            {referralTab === 'poster' && (

              <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#fafafa' }}>

                <h3 style={{ margin: '0 0 15px 0', fontWeight: '900' }}>扫码成为我的放克搭子</h3>

                <div style={{ width: '180px', height: '180px', border: '5px solid black', background: '#eee', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '5px 5px 0 #E6B422' }}>

                  <span style={{ fontSize: '50px' }}>📱</span>

                </div>

                <div style={{ marginTop: '20px', width: '100%', display: 'flex', gap: '10px' }}>

                  <button onClick={() => alert('海报已保存到您的手机相册！')} style={{ flex: 1, padding: '12px', background: '#00E676', border: '3px solid black', fontWeight: '900', fontSize: '14px' }}>保存相册</button>

                  <button onClick={() => alert('推广链接已复制，快去发给微信好友吧！')} style={{ flex: 1, padding: '12px', background: '#E6B422', border: '3px solid black', fontWeight: '900', fontSize: '14px' }}>复制链接</button>

                </div>

              </div>

            )}



            {referralTab === 'tiers' && (

              <div style={{ padding: '15px', overflowY: 'auto', flex: 1, background: '#fafafa' }}>

                <div style={{ border: '2px solid black', padding: '10px', marginBottom: '10px', background: refCount >= 3 ? '#e8f5e9' : 'white', opacity: refCount >= 3 ? 1 : 0.6 }}>

                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900' }}><span>🎖️ 萌新推销员 (3人)</span><span>{refCount >= 3 ? '✅' : '🔒'}</span></div>

                  <div style={{ fontSize: '11px', color: '#555', marginTop: '5px' }}>解锁专属称号，开启积分分润。</div>

                </div>

                <div style={{ border: '2px solid black', padding: '10px', marginBottom: '10px', background: refCount >= 10 ? '#fff8e1' : 'white', opacity: refCount >= 10 ? 1 : 0.6 }}>

                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900' }}><span>👑 金牌推广大使 (10人)</span><span>{refCount >= 10 ? '✅' : '🔒'}</span></div>

                  <div style={{ fontSize: '11px', color: '#8b2e1f', marginTop: '5px', fontWeight: 'bold' }}>特权：突破首单限制！每月额外发放【8折券】。</div>

                </div>

                <div style={{ border: '2px dashed black', padding: '10px', background: refCount >= 30 ? '#ffebee' : 'white', opacity: refCount >= 30 ? 1 : 0.6 }}>

                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900' }}><span>💎 终极合伙人 (30人)</span><span>{refCount >= 30 ? '✅' : '🔒'}</span></div>

                  <div style={{ fontSize: '11px', color: '#ff5252', marginTop: '5px', fontWeight: 'bold' }}>特权：每月发放【8折券】+【7折神券】！</div>

                </div>

              </div>

            )}

          </div>

        </div>

      )}



      {showVipModal && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>

          <div style={{ background: '#222', border: '5px solid #E6B422', width: '100%', maxWidth: '350px', display: 'flex', flexDirection: 'column', boxShadow: '10px 10px 0 #000', color: 'white' }}>

            <div style={{ padding: '20px', textAlign: 'center', borderBottom: '3px solid #E6B422' }}>

              <div style={{ fontSize: '24px', fontWeight: '900', color: '#E6B422' }}>放克街区通行证</div>

              <div style={{ fontSize: '14px', marginTop: '5px' }}>当前：<span style={{color:'#00E676', fontWeight:'bold'}}>Lv.{playerInfo.level} {playerInfo.title}</span></div>

            </div>

            <div style={{ padding: '15px', overflowY: 'auto', maxHeight: '50vh' }}>

              {vipTiers.map(tier => (

                <div key={tier.level} style={{ border: '2px solid #444', background: playerInfo.level >= tier.level ? '#333' : '#111', padding: '10px', marginBottom: '10px', opacity: playerInfo.level >= tier.level ? 1 : 0.5 }}>

                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900', color: playerInfo.level >= tier.level ? '#E6B422' : '#888' }}>

                    <span>Lv.{tier.level} {tier.name}</span><span>{tier.reqExp} EXP</span>

                  </div>

                  <div style={{ fontSize: '12px', color: '#ccc', marginTop: '5px' }}>👑 {tier.perks}</div>

                </div>

              ))}

            </div>

            <button onClick={() => setShowVipModal(false)} style={{ background: '#E6B422', color: 'black', border: 'none', padding: '15px', fontWeight: '900', fontSize: '18px' }}>关闭</button>

          </div>

        </div>

      )}



      {/* 👕 装备选择弹窗 - 真换装系统 */}

      {showEquipModal && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>

          <div style={{ background: 'white', border: '5px solid black', width: '100%', maxWidth: '350px', boxShadow: '10px 10px 0 #000' }}>

            <div style={{ background: 'black', color: 'white', padding: '15px', textAlign: 'center', fontWeight: '900' }}>

              选择{equipType}

            </div>

            <div style={{ padding: '15px', maxHeight: '60vh', overflowY: 'auto' }}>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>

                {realInventory

                  .filter(item => item.type === equipType && !item.isRedeemed)

                  .map(item => (

                    <div

                      key={item.id}

                      onClick={() => handleEquipItem(equipType, item.id)}

                      style={{

                        border: '2px solid black',

                        background: '#fff',

                        display: 'flex',

                        flexDirection: 'column',

                        alignItems: 'center',

                        cursor: 'pointer',

                        borderRadius: '4px',

                        padding: '8px',

                        boxShadow: '2px 2px 0 rgba(0,0,0,0.1)'

                      }}

                    >

                      <div style={{ fontSize: '24px', marginBottom: '4px' }}>{item.img}</div>

                      <div style={{ fontSize: '8px', fontWeight: 'bold', textAlign: 'center' }}>{item.name}</div>

                    </div>

                  ))}

              </div>

              {realInventory.filter(item => item.type === equipType && !item.isRedeemed).length === 0 && (

                <div style={{ textAlign: 'center', color: '#666', padding: '20px' }}>

                  暂无{equipType}物品

                </div>

              )}

            </div>

            <div style={{ borderTop: '3px solid black' }}>

              <button onClick={() => { setShowEquipModal(false); setEquipType(null); }} style={{ width: '100%', padding: '12px', background: '#ccc', border: 'none', fontWeight: '900', fontSize: '16px' }}>取消</button>

            </div>

          </div>

        </div>

      )}



      {/* 🖼️ 已兑换画廊 - 暗黑画廊模式 */}

      {showGallery && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: '#2c2c2c', zIndex: 10000, display: 'flex', flexDirection: 'column', padding: '20px' }}>

          <div style={{ background: '#1a1a1a', border: '4px solid #666', padding: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <div style={{ color: 'white', fontSize: '18px', fontWeight: '900' }}>🖼️ 已兑换画廊</div>

            <button onClick={() => setShowGallery(false)} style={{ background: '#666', color: 'white', border: '2px solid #999', padding: '8px 15px', fontWeight: 'bold' }}>关闭</button>

          </div>

         

          {galleryLoading ? (

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#999' }}>

              画廊加载中...

            </div>

          ) : (

            <div style={{ flex: 1, overflowY: 'auto' }}>

              {redeemedGallery.length === 0 ? (

                <div style={{ textAlign: 'center', color: '#999', padding: '40px' }}>

                  暂无已兑换物品

                </div>

              ) : (

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px' }}>

                  {redeemedGallery.map(item => (

                    <div key={item.id} style={{

                      background: '#333',

                      border: '3px solid #555',

                      borderRadius: '8px',

                      overflow: 'hidden',

                      filter: 'grayscale(50%)',

                      boxShadow: '4px 4px 0 rgba(0,0,0,0.5)'

                    }}>

                      <div style={{

                        height: '120px',

                        background: '#444',

                        display: 'flex',

                        justifyContent: 'center',

                        alignItems: 'center',

                        fontSize: '40px'

                      }}>

                        {getItemEmoji(item.type)}

                      </div>

                      <div style={{

                        padding: '10px',

                        background: '#222',

                        color: 'white'

                      }}>

                        <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>{item.name}</div>

                        <div style={{ fontSize: '10px', color: '#999' }}>

                          {new Date(item.updatedAt).toLocaleDateString()}

                        </div>

                        <div style={{ fontSize: '10px', color: '#00E676', marginTop: '4px' }}>

                          已兑换

                        </div>

                      </div>

                    </div>

                  ))}

                </div>

              )}

            </div>

          )}

        </div>

      )}



      {/* 🎆 全屏图鉴弹窗 - 巨幕波普风 */}

      {showFullscreenModal && fullscreenItem && (

        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.95)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>

          <div style={{

            background: fullscreenItem.rarity === 'LEGENDARY' ? '#FFD700' :

                       fullscreenItem.rarity === 'EPIC' ? '#9C27B0' :

                       fullscreenItem.rarity === 'RARE' ? '#2196F3' : '#000',

            border: '6px solid white',

            width: '100%',

            maxWidth: '400px',

            boxShadow: '12px 12px 0 rgba(255,255,255,0.3)',

            textAlign: 'center',

            borderRadius: '8px'

          }}>

            <div style={{ padding: '40px 20px' }}>

              <div style={{ fontSize: '100px', marginBottom: '20px', filter: 'drop-shadow(4px 4px 0 rgba(0,0,0,0.3))' }}>

                {fullscreenItem.img}

              </div>

              <h1 style={{ margin: '0 0 10px 0', fontSize: '28px', fontWeight: '900', color: 'white', textShadow: '2px 2px 0 rgba(0,0,0,0.5)' }}>

                🎉 恭喜解锁！

              </h1>

              <h2 style={{ margin: '0 0 20px 0', fontSize: '24px', fontWeight: '900', color: 'white' }}>

                {fullscreenItem.name}

              </h2>

              <div style={{

                background: 'white',

                color: fullscreenItem.rarity === 'LEGENDARY' ? '#FFD700' :

                       fullscreenItem.rarity === 'EPIC' ? '#9C27B0' :

                       fullscreenItem.rarity === 'RARE' ? '#2196F3' : '#000',

                padding: '10px 20px',

                borderRadius: '20px',

                fontSize: '16px',

                fontWeight: 'bold',

                display: 'inline-block',

                marginBottom: '30px'

              }}>

                {getRarityLabel(fullscreenItem.rarity)} 稀有度

              </div>

              <button onClick={() => { setShowFullscreenModal(false); setFullscreenItem(null); }} style={{

                background: 'white',

                color: fullscreenItem.rarity === 'LEGENDARY' ? '#FFD700' :

                       fullscreenItem.rarity === 'EPIC' ? '#9C27B0' :

                       fullscreenItem.rarity === 'RARE' ? '#2196F3' : '#000',

                border: '3px solid white',

                padding: '15px 40px',

                fontSize: '18px',

                fontWeight: '900',

                cursor: 'pointer',

                borderRadius: '30px',

                boxShadow: '4px 4px 0 rgba(0,0,0,0.3)'

              }}>

                太棒了！

              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}



export default Profile;